var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M-1-2h48v48H-1z","key":0}),React.createElement("path",{"fill":"#E86C60","fillRule":"nonzero","d":"M33 0a12.971 12.971 0 0 0-10 4.698A12.971 12.971 0 0 0 13 0C5.832 0 0 5.832 0 13c0 12.332 21.453 30.027 22.367 30.774a.995.995 0 0 0 1.266 0C24.547 43.027 46 25.332 46 13c0-7.168-5.832-13-13-13z","key":1})]));
}

Heart.defaultProps = {"width":"46","height":"44","viewBox":"0 0 46 44"};

module.exports = Heart;

Heart.default = Heart;
